import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { useWindowScrollTop } from '../../sporsmalsflyt/hooks';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.TyveriInnbruddEllerRan,
        tekst: 'Tyveri, innbrudd eller ran av reisegods',
    },
    {
        id: KategoriSvarId.ReiseSkadetReisegods,
        tekst: 'Skadet reisegods',
    },
    {
        id: KategoriSvarId.ReiseMistetReisegods,
        tekst: 'Mistet reisegods',
    },
    {
        id: KategoriSvarId.ReiseGjenglemtReisegods,
        tekst: 'Gjenglemt reisegods',
    },
];

export const ReiseMistetSkadetStjalet = () => {
    const navigate = useNavigate();
    const windowScollTop = useWindowScrollTop();
    windowScollTop();

    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.TyveriInnbruddEllerRan) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.ReisegodsTyveri));
        } else if (svarId === KategoriSvarId.ReiseMistetReisegods) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.MistetReisegods));
        } else if (svarId === KategoriSvarId.ReiseSkadetReisegods) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.SkadetReisegods));
        } else if (svarId === KategoriSvarId.ReiseGjenglemtReisegods) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.GjenglemtReisegods));
        }
    };

    const goback = () => navigate(-1);

    return (
        <GruppeLandingsside
            title="Mistet, skadet eller stjålet reisegods"
            onNext={onNext}
            navigateToParent={goback}
            alternativer={alternativer}
            svgCardType={SvgCardType.BagasjeFlyplass}
            kategoriId="reise-mistet-skade-stjalet-reisegods"
        />
    );
};
